export default {
      id: "my-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#my",
      toString: function () {
        return this.url;
      }
    }